import React, {useMemo, useState} from 'react'
import moment from 'moment'
import {KTSVG} from '../../../../../_metronic/helpers'
import {useIntl} from 'react-intl'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import {toast} from 'react-toastify'
dayjs.extend(utc)
dayjs.extend(timezone)

const getFileIcon = (extension: string) => {
  switch (extension.toLowerCase()) {
    case 'mp4':
      return '/media/icons/duotone/General/live_tv.svg'
    case 'mdt':
      return '/media/icons/duotone/General/video_file.svg'
    case 'jpeg':
      return '/media/icons/duotone/General/image.svg'
    case 'jpg':
      return '/media/icons/duotone/General/image.svg'
    default:
      return '/media/icons/duotone/Files/File.svg'
  }
}

const getFileIconClass = (extension: string) => {
  switch (extension.toLowerCase()) {
    case 'mp4':
      return 'icon mp4-icon'
    case 'mdt':
      return 'icon mdt-icon'
    case 'jpg':
    case 'jpeg':
      return 'icon jpg-icon'
    default:
      return 'icon'
  }
}

const extractExtension = (url: string) => {
  try {
    const pathname = new URL(url).pathname
    const lastSegment = pathname.substring(pathname.lastIndexOf('/') + 1)
    const dotIndex = lastSegment.lastIndexOf('.')
    return dotIndex !== -1 ? lastSegment.substring(dotIndex + 1) : ''
  } catch {
    return ''
  }
}

const FilesRow: React.FC<any> = ({
  file,
  setShow,
  setLocation,
  index,
  setShowDeleteModal,
  setFileId,
  getShareFileInfo,
}) => {
  const intl = useIntl()
  const [downloading, setDownloading] = useState<boolean>(false)

  const extension = useMemo(() => {
    if (!file?.fileAccessLink) return ''
    return extractExtension(file.fileAccessLink)
  }, [file?.fileAccessLink])

  const iconPath = useMemo(() => {
    return getFileIcon(extension)
  }, [extension])

  const iconClass = useMemo(() => {
    return getFileIconClass(extension)
  }, [extension])

  const downloadFile = async (fileUrl: string) => {
    setDownloading(true)
    try {
      if (!fileUrl) {
        throw new Error('File URL not found')
      }

      const fileName = fileUrl.split('/').pop()?.split('?')[0]
      if (!fileName) {
        setDownloading(false)
        throw new Error('Invalid file name')
      }

      const response = await fetch(fileUrl)
      if (!response.ok) {
        setDownloading(false)
        throw new Error(`Download failed (${response.status})`)
      }

      const blob = await response.blob()
      const blobUrl = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = blobUrl
      link.download = fileName

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      window.URL.revokeObjectURL(blobUrl)
      setDownloading(false)
    } catch (error: any) {
      setDownloading(false)
      console.error('Download error:', error)
      toast.error(error?.message || 'Unable to download file. Please try again later.')
    }
  }

  const extractVehicleNo = (title: string) => {
    const match = title.match(/vehicle:\s*(.*)$/i)
    return match ? match[1].trim() : '-'
  }

  return (
    <>
      <tr
        className='hover-effect'
        onClick={() => {
          if (file?.fileAccessLink) {
            window.open(file.fileAccessLink, '_blank')
          }
        }}
      >
        <td className='file-index'>
          <div className='index'>{index + 1}</div>
        </td>

        {/* <td className='file-title'>{file.title}</td> */}
        <td className='file-title'>{file.title ? extractVehicleNo(file.title) : '-'}</td>
        <td>
          {file.startEpoch
            ? dayjs.unix(file.startEpoch).utc().tz(dayjs.tz.guess()).format('YYYY-MM-DD, HH:mm:ss')
            : '-'}
        </td>
        <td>
          {file.startEpoch && file.endEpoch
            ? moment.unix(file.endEpoch).diff(moment.unix(file.startEpoch), 's') + 's'
            : '-'}
        </td>
        <td className='file-type'>
          <span className='d-flex align-items-center extension'>
            <KTSVG path={iconPath} className={iconClass} fill='currentColor' />
            <span className='file-extension'>
              {extractExtension(file.fileAccessLink).toUpperCase() ?? ''}
            </span>
          </span>
        </td>
        <td className='d-flex align-items-center'>
          {file.startLat &&
          file.startLong &&
          !isNaN(Number(file.startLat)) &&
          !isNaN(Number(file.startLong)) ? (
            <div
              onClick={(e) => {
                e.stopPropagation()
                setShow(true)
                setLocation({
                  Lat: file.startLat,
                  Long: file.startLong,
                })
              }}
              className='cursor-pointer'
            >
              <KTSVG
                path={'/media/icons/duotone/General/Transportation.svg'}
                className='svg-icon-2'
              />
              <span className='ml-4'>{intl.formatMessage({id: 'GENERAL.LABEL.VIEW'})}</span>
            </div>
          ) : (
            '-'
          )}
        </td>
        <td>{file.deviceId ? file.deviceId : '-'}</td>
        {/* <td>{file.comment}</td> */}
        {/* <td>
          <a href={file.fileAccessLink} target='_blank' rel='noopener noreferrer'>
            <KTSVG path={iconPath} className='svg-icon-2' />
          </a>
        </td> */}
        <td className='text-center d-flex justify-content-end'>
          <span className='action'>
            {/* <i
              className='fas fa-trash text-danger'
              onClick={(e) => {
              setShowDeleteModal
                e.stopPropagation()
                deleteFile(file.id)
              }}
            ></i> */}
            <span
              className='delete-action'
              onClick={(e) => {
                e.stopPropagation()
                setShowDeleteModal(true)
                setFileId(file.id)
              }}
            >
              <KTSVG
                path='/media/icons/duotone/General/delete.svg'
                className='delete-icon'
                fill='currentColor'
              />
              <span className='label custom-delete'>
                {intl.formatMessage({id: 'GENERAL.LABEL.DELETE'})}
              </span>
            </span>
            <span className='sharelink-action'>
              <KTSVG
                path='/media/icons/duotone/General/Sharelink.svg'
                fill='currentColor'
                className='sharelink-icon'
              />

              <span
                className='label custom-sharelink'
                onClick={(e) => {
                  e.stopPropagation()
                  getShareFileInfo(file)
                }}
              >
                {intl.formatMessage({id: 'GENERAL.LABEL.SHARE'})}
              </span>
            </span>
            <span className='download-action'>
              {downloading ? (
                <span className='spinner-border spinner-border-sm text-primary align-middle'></span>
              ) : (
                <KTSVG
                  path='/media/icons/duotone/General/arrow_circle_down.svg'
                  className='download-icon'
                  fill='currentColor'
                />
              )}

              <span
                className='label custom-download'
                onClick={(e) => {
                  e.stopPropagation()
                  downloadFile(file.fileAccessLink)
                }}
              >
                {intl.formatMessage({id: 'GENERAL.LABEL.DOWNLOAD'})}
              </span>
            </span>
          </span>
        </td>
      </tr>
    </>
  )
}

export default FilesRow
